<script>
    import { onMount } from "svelte"

    import "./$styles/bulma.scss"
    import "./$styles/global.scss"

    import Router from "svelte-spa-router"
    import { routes } from "./routes"

    onMount(() => {
        document.getElementById('app')?.classList.remove('theme-menu-dark')
    })
</script>

<div id="app" class="app-size">
    <Router {routes} />
</div>

<style>
    .app-size {
        width: 100vw;
        height: 100vh;
        overflow: auto;
        background-color: white;
    }
</style>
